<template>
    <div class="specialist-card" @click="viewProfile">
        <div class="specialist-card__image" v-if="this.skeleton">
            <div class="skeleton" style="min-height: 287px;"></div>
        </div>
        <template v-else>
            <div class="specialist-card__image" >
                <div class="specialist-card__background" ref="imageBackground"></div>
                <img class="specialist-card__avatar" :src="imageUrl" :alt="name" crossorigin="anonymous" v-if="imageUrl" ref="image" />
                <img class="specialist-card__avatar" src="@/assets/images/doctors/doctor1.jpg" :alt="name" v-else>
                <div class="specialist-card__overlay"></div>
            </div>

            <template v-if="isActive">
                <div class="specialist-card__info"></div>
                <div class="specialist-card__status">
                    <div class="specialist-card__status--bullet"></div>
                    <div class="specialist-card__status--text">
                        Disponibil acum
                    </div>
                </div>
            </template>
            
        </template>
        <div class="specialist-card__preview" v-if="this.skeleton">
            <h3 class="specialist-card__category skeleton" style="min-height: 14px; max-width: 125px;"></h3>
            <h2 class="specialist-card__name skeleton" style="min-height: 21px; max-width: 200px;"></h2>
            <p class="specialist-card__paragraph skeleton" style="min-height: 38px;"></p>
            <div class="specialist-card__stars skeleton" style="min-height: 14px; max-width: 100px;">
                
            </div>
        </div>
        <div class="specialist-card__preview" v-else>
            <h3 class="specialist-card__title">
                {{title}}
            </h3>
            <h2 class="specialist-card__name">
                {{name}}
            </h2>
            <p class="specialist-card__paragraph">
                {{text}}
            </p>
            <UiStarRating class="specialist-card__stars" :rating="rating" />
        </div>
    </div>
</template>

<script>
    import grade from 'grade-js'
    import UiStarRating from '@/components/ui/StarRating'

    export default {
        components: {
            UiStarRating
        },
        props: {
            id: {
                type: Number,
                default: 1
            },
            title: {
                type: String,
                default: ''
            },
            name: {
                type: String,
                default: ''
            },
            text: {
                type: String,
                default: ''
            },
            imageUrl: {
                type: String,
                default: ''
            },
            rating: {
                type: Number,
                default: 0
            },
            skeleton: {
                type: Boolean,
                default: false
            },
            isActive: {
                type: [Boolean, Number],
                default: false
            }
        },
        methods: {
            viewProfile() {
                this.$router.push('/specialists/profile/' + this.id)
            },
            processBackground() {
                let processBackgroundEnabled = false; //Added by RJ - temporar, dezactivam processBg

                if(processBackgroundEnabled)
                    try {
                        if (this.$refs.image === undefined) {
                            return;
                        }

                        this.$refs.image.onload = () => {
                            const image = this.$refs.image;

                            if (image === undefined) {
                                return;
                            }

                            let gradientData = []
                            let imageData = [];

                            let canvas = document.createElement('canvas');
                            let ctx = canvas.getContext('2d');

                            let imageDimensions = {
                                width: 0,
                                height: 0
                            };

                            imageDimensions.width = image.width * 0.1;
                            imageDimensions.height = image.height * 0.1;

                            canvas.width = imageDimensions.width;
                            canvas.height = imageDimensions.height;
                            ctx.drawImage(image, 0, 0, imageDimensions.width, imageDimensions.height);

                            imageData = ctx.getImageData(0, 0, imageDimensions.width, imageDimensions.height).data;
                            imageData = Array.from(imageData);

                            let chunked = imageData.reduce((ar, it, i) => {
                                const ix = Math.floor(i / 4)
                                if (!ar[ix]) {
                                    ar[ix] = []
                                }
                                ar[ix].push(it);
                                return ar
                            }, []);

                            chunked = chunked.filter(rgba => {
                                return rgba.slice(0, 2).every(val => val < 250) && rgba.slice(0, 2).every(val => val > 0)
                            });

                            chunked = chunked.reduce((accum, current) => {
                                let key = current.join('|');
                                if (!accum[key]) {
                                    accum[key] = 1;
                                    return accum
                                }
                                accum[key] = ++(accum[key]);
                                return accum
                            }, {});

                            const occurs = Object.keys(chunked).map(key => {
                                const rgbaKey = key;

                                let components = key.split('|');

                                let brightness = ((components[0] * 299) + (components[1] * 587) + (components[2] * 114)) / 1000
                                    return {
                                        rgba: rgbaKey.split('|'),
                                        occurs: chunked[key],
                                        brightness
                                    }
                                }
                            ).sort((a, b) => a.occurs - b.occurs).reverse().slice(0, 10);

                            let sorted = occurs.sort((a, b) => a.brightness - b.brightness).reverse()
                            let top = [sorted[0], sorted[sorted.length - 1]]

                            const val = top.map((color, index) => {
                                return `rgb(${color.rgba.slice(0, 3).join(',')}) ${index == 0 ? '0%' : '75%'}`
                            }).join(',');

                            const prefixes = ['webkit'];
                            let gradientProperty = prefixes.map(prefix => {
                                return `background-image: -${prefix}-linear-gradient(
                                            135deg,
                                            ${val}
                                        )`
                            }).concat([`background-image: linear-gradient(
                                        135deg,
                                        ${val}
                                    )`]).join(';')

                            let textProperty;
                            const start = top[0].rgba.slice(0,3);
                            const end = top[1].rgba.slice(0,3);

                            let w = 0.5 * 2 - 1;
                            let w1 = (w + 1) / 2.0;
                            let w2 = 1 - w1;
                            let rgb = [parseInt(start[0] * w1 + end[0] * w2), parseInt(start[1] * w1 + end[1] * w2), parseInt(start[2] * w1 + end[2] * w2)];

                            let o = Math.round(((parseInt(rgb[0]) * 299) + (parseInt(rgb[1]) * 587) + (parseInt(rgb[2]) * 114)) /1000);

                            if (o > 125) {
                                textProperty = 'color: #000';
                            } else { 
                                textProperty = 'color: #fff';
                            }

                            this.$refs.imageBackground.style = `${ gradientProperty }; ${ textProperty }`;
                        }
                    } catch(e) {
                        console.log(e);
                    }
                else try {
                    this.$refs.imageBackground.style = `background: white;`;
                } catch (e) {}
            }
        },
        mounted() {
            this.processBackground();
        },
    }
</script>

<style lang="scss" scoped>
    .specialist-card {
        color: inherit;
        display: flex;
        flex-direction: column;
        //max-width: 250px; //TBD
        min-width: 250px;
        position: relative;
        cursor: pointer;
        text-decoration: none;
        box-shadow: 0px 0px 20px #0000000F;
        transition: all 0.3s ease;
        margin: 0px auto;
        background-color: $color-card;
        width: 100%;

        // @include media-breakpoint-up(sm) {
        //     max-width: 250px;
        // }

        @include media-breakpoint-up(md) {
            max-width: 250px;
            margin: initial;
        }

        &__image {
            height: 100%;
            min-height: 287px;
            max-height: 287px;
            position: relative;
            transition: all 0.3s ease;

            display: flex;
            justify-content: center;
            overflow: hidden;
        }
        
        &__info {
            width: 100%;
            height: 29px;
            opacity: 0.7;
            background: $gradient-nexyo;
            margin-top: -29px;
            z-index: 10;
            display: flex;
            justify-content: center;
            align-items: center;
            text-align: center;
        }
        
        &__status {
            width: 100%;
            height: 29px;
            margin-top: -29px;
            z-index: 11;
            display: flex;
            justify-content: center;
            align-items: center;
            text-align: center;
            
            &--bullet {
                background: #00CD98; //$color-anytime-button
                border-radius: 8px;
                height: 16px;
                width: 16px;
                margin: 0 3px;
            }
            
            &--text {
                font-family: 'DIN Pro', sans-serif;
                font-style: normal;
                font-weight: bold;
                font-size: 15px;
                line-height: 17px;
                display: flex;
                align-items: center;
                text-align: center;
                color: #FFFFFF;
                z-index: 11;
                margin: 0 3px;
            }
        }

        &__avatar {
            min-height: inherit;
            object-fit: contain;
            z-index: 10;
            position: relative;
        }

        &__background {
            background: linear-gradient(135deg,
                    $color-primary,
                    $color-secondary);
            height: 100%;
            left: 0;
            mix-blend-mode: normal;
            position: absolute;
            top: 0;
            transition: opacity 0.3s;
            width: 100%;
            z-index: 5;
        }

        &__overlay {
            background: linear-gradient(135deg,
                    $color-primary,
                    $color-secondary);
            height: 100%;
            left: 0;
            mix-blend-mode: normal;
            opacity: 0;
            position: absolute;
            top: 0;
            transition: opacity 0.3s;
            width: 100%;
            z-index: 15;
        }

        &:hover{
            box-shadow: none;
            background-color: transparent;
        }

        &:hover &__overlay {
            opacity: 0.7;
        }

        &__preview {
            transition: all 0.3s ease;
            display: flex;
            flex-direction: column;
            padding-bottom: 15px;

            & > * {
                margin-left: 10px;
                margin-right: 10px;
            }
        }

        &__title {
            font-size: 14px;
            font-weight: 500;                
            letter-spacing: -0.2px;
            margin-top: 12px;
        }

        &__name {
            font-size: 21px;
            font-weight: 500;
            letter-spacing: -0.6px;
            margin-top: 20px;
            max-height: 21px;
            overflow: hidden;
        }

        &__paragraph {
            font-size: 14px;
            font-weight: 300;
            line-height: 1.4;
            margin-top: 15px;
            max-height: 39.2px;
            overflow: hidden;
        }

        &__stars{
            margin-top: 15px;
        }
        

        &:hover &__name {
            color: $color-primary;
        }
    }
</style>